import { getIcon } from '../../../utils/icons';
import type { LucideIcon } from 'lucide-react';
import { HomeBannerConfig } from '../types';

interface WelcomeBannerProps {
  config?: HomeBannerConfig;
}

/**
 * Welcome banner component with configurable title, subtitle, and icon
 */
export const WelcomeBanner = ({ config }: WelcomeBannerProps) => {
  const title = config?.title || 'Welcome';
  const subtitle = config?.subtitle;
  const iconName = config?.icon || 'home';

  const Icon = getIcon(iconName) as LucideIcon;

  return (
    <div className="bg-[var(--appvia-background-paper)] rounded-lg shadow-[var(--appvia-shadow-2)] p-6 mb-6">
      <h1 className="text-2xl font-bold mb-2 flex items-center text-[var(--appvia-text-primary)]">
        {Icon && (
          <Icon className="w-6 h-6 mr-2 text-[var(--appvia-primary-light)]" />
        )}
        {title}
      </h1>
      {subtitle && (
        <p className="text-[var(--appvia-text-secondary)]">{subtitle}</p>
      )}
    </div>
  );
};
